import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, Button, Typography, Flex, Row, Input } from "antd";
import {
  PrinterOutlined,
  AppstoreAddOutlined,
  CopyOutlined,
  AppleOutlined,
  AndroidOutlined,
  MailOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import Navbar from "../../components/Navbar";
import {
  addUsersTourDataToUrl,
  getUsersTourDataFromUrl,
} from "../../common/helper";
import StyledCard from "../../components/StyledCard";
import Title from "antd/es/typography/Title";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./Post.css";
import DownloadOnAppleStore from "../../svgs/DownloadOnAppleStore";
import {
  FaClipboardList,
  FaEnvelope,
  FaRegCalendar,
  FaRegClock,
  FaUser,
  FaGlobe,
} from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { FaShareAlt } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import CardIconForBrand from "../../components/CardIconForBrand";
import tz_lookup from "tz-lookup";
import DownloadWegetherModal from "../../components/DownloadWegetherModal";
import PartyIcon from "../../components/PartyIcon";
import PartyDetailsModal from "../../components/PartyDetailsModal";

export const Post = () => {
  const location = useLocation();
  const [cardData, setCardData] = useState(null);
  const initialUsersTourData = getUsersTourDataFromUrl(window.location.href);
  const [titleLevel, setTitleLevel] = useState({});
  const [downloadAppModalVisible, setDownloadAppModalVisible] = useState(false);
  const [partyDetailsModalVisible, setPartyDetailsModalVisible] =
    useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 670) {
        setTitleLevel({ main: 2, sub: 4 });
      } else {
        setTitleLevel({ main: 4, sub: 5 });
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDownloadApp = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.wegether_tourist",
      "_blank"
    );
  };

  const breadcrumbs = [
    { label: "Home", path: addUsersTourDataToUrl("/", initialUsersTourData) },
    { label: "Booking Confirmation" },
  ];

  const handleCopyLink = () => {
    const input = document.getElementById("page-link");
    // Create a temporary textarea to hold the value and copy it
    const tempTextarea = document.createElement("textarea");
    document.body.appendChild(tempTextarea);
    tempTextarea.value = input.value; // Set the value of the input to the textarea
    tempTextarea.select(); // Select the text in the temporary textarea
    document.execCommand("copy"); // Copy the selected text
    document.body.removeChild(tempTextarea); // Clean up by removing the temporary textarea
  };

  const handlePrintPage = () => {
    const content = document.body; // Or specify the part of the page you want to print
    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const aspectRatio = imgWidth / imgHeight;

      const pdfWidth = pageWidth;
      const pdfHeight = pdfWidth / aspectRatio;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pageHeight);
      pdf.save("page.pdf");
    });
  };

  const downloadPdf = () => {
    const navbar = document.getElementById("navbar");

    // Set fixed width
    document.getElementById("root").style.width = "1300px";

    const initialValueOfGrid =
      document.getElementById("post-checkout-grid").style.gridTemplateColumns;
    document.getElementById("post-checkout-grid").style.gridTemplateColumns =
      "1fr";

    navbar.style.display = "none";

    const element = document.body; // Target the entire body or a specific element

    html2canvas(element, {
      scale: 1, // Adjust scale if necessary
      width: 1300, // Ensure canvas matches fixed width
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const fixedWidth = 1400; // Fixed width for the PDF
      const fixedHeight = (canvas.height / canvas.width) * fixedWidth; // Maintain aspect ratio

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const ratio = pageWidth / fixedWidth; // Scale to fit A4 page width
      const scaledHeight = fixedHeight * ratio; // Scaled height in PDF units

      let y = 0;

      while (y < scaledHeight) {
        const cropCanvas = document.createElement("canvas");
        cropCanvas.width = fixedWidth;
        cropCanvas.height = (pageHeight / pageWidth) * fixedWidth;

        const ctx = cropCanvas.getContext("2d");
        ctx.drawImage(
          canvas,
          0,
          ((y / ratio) * canvas.width) / fixedWidth, // Adjust cropping to scaled dimensions
          canvas.width,
          cropCanvas.height * (canvas.width / fixedWidth),
          0,
          0,
          cropCanvas.width,
          cropCanvas.height
        );

        const croppedImg = cropCanvas.toDataURL("image/png");
        if (y > 0) pdf.addPage();
        pdf.addImage(croppedImg, "PNG", 0, 0, pageWidth, pageHeight);

        y += cropCanvas.height * ratio;
      }

      pdf.save("webpage.pdf");
    });

    navbar.style.display = "block";

    // Restore original styles
    document.getElementById("root").style.width = "100%";
    document.getElementById("post-checkout-grid").style.gridTemplateColumns =
      initialValueOfGrid;
  };

  return (
    <>
      <Navbar
        breadcrumbs={breadcrumbs}
        headerDownloadButtonOnClick={() => setDownloadAppModalVisible(true)}
      />
      <div style={{ backgroundColor: "#F0F2F5", minHeight: "100vh" }}>
        <div
          style={{
            padding: "20px",
            maxWidth: "1400px",
            margin: "auto",
            marginTop: "80px",
          }}
        >
          <div
            id="post-checkout-grid"
            style={{
              display: "grid",
              gap: "20px",
              gridTemplateColumns:
                window.innerWidth < 1100 ? "1fr" : "repeat(2, 1fr)",
            }}
          >
            <div>
              <div class="card" style={{}}>
                <div
                  class="container-card bg-yellow-box"
                  style={{
                    background: "linear-gradient(71deg, white, white, white)",
                    height: window.innerWidth > 1100 ? "350px" : "auto",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <FaMapLocationDot style={{ color: "#FA5705" }} size={25} />
                    <Title
                      style={{ margin: 0, textAlign: "center" }}
                      level={titleLevel.main}
                    >
                      Booking Details
                    </Title>
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    {[
                      {
                        label: "First Name",
                        value: initialUsersTourData.firstName,
                      },
                      {
                        label: "Email",
                        value: initialUsersTourData.email,
                      },
                      {
                        label: "Experience Name",
                        value: initialUsersTourData.experienceName,
                      },
                      {
                        label: "Timezone:",
                        value: initialUsersTourData.timeZone,
                        icon: <FaGlobe />,
                      },
                      {
                        label: "Date",
                        value: initialUsersTourData.date,
                        icon: <FaRegCalendar />,
                      },
                      {
                        label: "Meetup Time",
                        value: initialUsersTourData.meetUpTime,
                        icon: <FaRegClock />,
                      },
                      {
                        label: "Wrapup Time",
                        value: initialUsersTourData.endTime,
                        icon: <FaRegClock />,
                      },
                      {
                        label: "Party:",
                        value: (
                          <div
                            onClick={() =>
                              setPartyDetailsModalVisible((prev) => !prev)
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                            }}
                          >
                            {initialUsersTourData.party.size}{" "}
                            {initialUsersTourData.activityType}{" "}
                          </div>
                        ),
                        icon: (
                          <PartyIcon
                            partyType={initialUsersTourData.activityType}
                          />
                        ),
                      },
                    ].map((item, index) => (
                      <Flex
                        key={index}
                        justify="space-between"
                        style={{ marginBottom: "10px" }}
                      >
                        <Title level={titleLevel.sub} style={{ margin: 0 }}>
                          {item.label}
                        </Title>
                        <Title
                          level={titleLevel.sub}
                          style={{
                            margin: 0,
                            fontWeight: "500",
                            color: "#606060",
                            gap: "0.5rem",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {item.icon && item.icon}
                          <Title
                            level={titleLevel.sub}
                            style={{
                              margin: 0,
                              fontWeight: "500",
                              color: "#606060",
                              textAlign: "end",
                            }}
                          >
                            {item.value}
                          </Title>
                        </Title>
                      </Flex>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="card" style={{ height: "100%" }}>
                <div
                  class="container-card bg-yellow-box"
                  style={{
                    background: "linear-gradient(71deg, white, white, white)",
                    height: window.innerWidth > 1100 ? "350px" : "auto",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <FaClipboardList style={{ color: "#FA5705" }} size={25} />
                    <Title
                      style={{ margin: 0, textAlign: "center" }}
                      level={titleLevel.main}
                    >
                      Payment Details
                    </Title>
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    {initialUsersTourData ? (
                      [
                        {
                          label: "Payment Method:",
                          value: initialUsersTourData.paymentType,
                        },
                        {
                          label: "Transaction ID:",
                          value: initialUsersTourData.id,
                        },
                        {
                          label: "Card Details:",
                          value: (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CardIconForBrand
                                brand={initialUsersTourData?.brand || ""}
                              />
                              ***********
                              {initialUsersTourData.last4}
                            </div>
                          ),
                        },
                        {
                          label: "Subtotal:",
                          value: initialUsersTourData.subTotal,
                        },
                        {
                          label: "Booking Fee (10%):",
                          value: initialUsersTourData.tax,
                        },
                        {
                          label: "Total Payment:",
                          value: initialUsersTourData.total,
                        },

                        //   { label: "Object:", value: initialUsersTourData.object },
                      ].map((item, index) => (
                        <Flex
                          key={index}
                          justify="space-between"
                          style={{ marginBottom: "10px" }}
                        >
                          <Title
                            level={titleLevel.sub}
                            style={{ margin: 0, textWrap: "nowrap" }}
                          >
                            {item.label}
                          </Title>
                          <Title
                            level={titleLevel.sub}
                            style={{
                              margin: 0,
                              fontWeight: "500",
                              color: "#606060",
                              textAlign: "end",
                            }}
                          >
                            {item.value}
                          </Title>
                        </Flex>
                      ))
                    ) : (
                      <p>Loading details...</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div style={{ position: "relative" }}>
                <StyledCard
                  gradient={"linear-gradient(71deg, white, white, white)"}
                  // setMinHeight={true}
                >
                  {" "}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      minHeight: window.innerWidth > 1100 ? "65px" : "auto",
                    }}
                  >
                    <FaShareAlt style={{ color: "#FA5705" }} size={25} />
                    <Title
                      style={{ margin: 0, textAlign: "center" }}
                      level={titleLevel.main}
                    >
                      Share
                    </Title>
                  </div>
                  <div style={{ height: "30px" }}></div>
                  <Input
                    id="page-link"
                    style={{
                      display: "block",
                      borderRadius: "8px",
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      height: "40px",
                      padding: "12px",
                      marginBottom: "40px",
                      borderColor: "#FA5705",
                    }}
                    className="custom-input"
                    value={window.location.href}
                    addonAfter={
                      <Button
                        type="link"
                        icon={<CopyOutlined />}
                        onClick={handleCopyLink}
                        style={{
                          // height: "40px",
                          // padding: "0 12px",
                          fontSize: "16px",
                          // lineHeight: "1.5",
                          color: "#FA5705",
                        }}
                        className="custom-copy-button"
                      >
                        Copy
                      </Button>
                    }
                    readOnly
                  />
                  <div style={{ height: "50px" }}></div>
                  <div
                    style={
                      {
                        // position: "absolute", // Absolute positioning relative to the wrapper
                        // bottom: "20px", // Distance from the bottom of the wrapper
                        // right: "20px", // Distance from the right of the wrapper
                      }
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: window.innerWidth < 400 ? "1px" : "5px",
                        marginRight: window.innerWidth < 400 ? "0px" : "30px",
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#FA5705",
                          color: "white",
                          fontWeight: "600",
                          borderRadius: "5px",
                          height: "2.5rem",
                          fontFamily: "Poppins",
                        }}
                        type="default"
                        icon={<PrinterOutlined />}
                        onClick={downloadPdf}
                        size="large"
                      >
                        Print Page
                      </Button>
                      <a
                        style={{
                          backgroundColor: "#FA5705",
                          color: "white",
                          fontWeight: "600",
                          borderRadius: "5px",
                          height: "2.5rem",
                          fontFamily: "Poppins",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textDecoration: "none", // Ensure it looks like a button
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                        href={`mailto:?subject=Check out this page&body=${encodeURIComponent(
                          window.location.href
                        )}`}
                      >
                        <MailOutlined style={{ marginRight: "0.5rem" }} />
                        Share by Email
                      </a>
                    </div>
                  </div>
                </StyledCard>
              </div>
            </div>

            <div>
              <div>
                <div class="card" style={{}}>
                  <div
                    class="container-card bg-yellow-box"
                    style={{
                      background: "linear-gradient(71deg, white, white, white)",
                      minHeight: "100px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <FaDownload style={{ color: "#FA5705" }} size={25} />
                      <Title
                        style={{ margin: 0, textAlign: "center" }}
                        level={titleLevel.main}
                      >
                        Download
                      </Title>
                    </div>
                    <p
                      style={{
                        margin: "20px 0",
                        fontSize: "16px",
                        fontFamily: "Poppins, sans-serif",
                        color: "#606060",
                        lineHeight: "1.5",
                      }}
                    >
                      Please download our app to access features such as
                      contacting guides, managing trips, and more!
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1rem",
                        flexWrap: "wrap",
                        flexDirection: "row",
                      }}
                    >
                      {/* Apple App Download */}
                      <div
                        style={{
                          flex: "1",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          window.open("LINK_TO_YOUR_IOS_APP", "_blank")
                        }
                      >
                        <DownloadOnAppleStore />
                      </div>

                      {/* Google Play App Download */}
                      <div
                        style={{
                          flex: "1",
                          display: "flex",
                          justifyContent: "center", // Horizontal centering
                          alignItems: "center", // Vertical centering
                          padding: "0.5rem",
                          cursor: "pointer",
                          height: "100%", // Ensure the parent has a defined height
                        }}
                        onClick={() =>
                          window.open("LINK_TO_YOUR_ANDROID_APP", "_blank")
                        }
                      >
                        <img
                          src={"/GetItOnGooglePlay_Badge.png"}
                          style={{
                            width: window.innerWidth > 495 ? "205px" : "186px",
                            height: "auto",
                            marginTop: "30px",
                          }}
                          alt="Get it on Google Play"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DownloadWegetherModal
        downloadAppModalVisible={downloadAppModalVisible}
        setDownloadAppModalVisible={setDownloadAppModalVisible}
      />
      <PartyDetailsModal
        guestModalVisible={partyDetailsModalVisible}
        setGuestModalVisible={setPartyDetailsModalVisible}
        guests={initialUsersTourData?.party}
        isShared={initialUsersTourData?.activityType?.toLowerCase() == "shared"}
      />
    </>
  );
};
